import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateCollectionPrivacyMutationVariables = Types.Exact<{
  collectionId: Types.Scalars['ID']['input'];
  isPrivate?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateCollectionPrivacyMutation = { __typename?: 'Mutation', updateCollection?: { __typename?: 'UpdateCollectionPayload', collection?: { __typename?: 'Collection', id: string, private?: boolean | null } | null } | null };


export const UpdateCollectionPrivacy = /*#__PURE__*/ gql`
    mutation UpdateCollectionPrivacy($collectionId: ID!, $isPrivate: Boolean) {
  updateCollection(input: {collectionId: $collectionId, private: $isPrivate}) {
    collection {
      id
      private
    }
  }
}
    ` as unknown as DocumentNode<UpdateCollectionPrivacyMutation, UpdateCollectionPrivacyMutationVariables>;

          

          export const useUpdateCollectionPrivacyMutation = (options?:MutationHookOptions<UpdateCollectionPrivacyMutation, UpdateCollectionPrivacyMutationVariables>) => useMutation(UpdateCollectionPrivacy, options);
          

          export type UpdateCollectionPrivacyMutationOptions = MutationHookOptions<UpdateCollectionPrivacyMutation, UpdateCollectionPrivacyMutationVariables>;

          

          export type UpdateCollectionPrivacyMutationResult = ReturnType<typeof useUpdateCollectionPrivacyMutation>[1];

          
